const storageKey = 'hivecloud:runtime-claim'
const maximumAgeMs = 5 * 60 * 1000
let pending: { userCode: string; expiresAt: number } | undefined

export function normalizeRuntimeClaimCode(value: string): string {
  const normalized = value.trim().toUpperCase()
  if (!/^[A-Z2-9]{4}-[A-Z2-9]{4}$/.test(normalized)) throw new Error('runtime_claim_code_invalid')
  return normalized
}

export function captureRuntimeClaimFragment(location: Pick<Location, 'hash' | 'pathname' | 'search'>, history: Pick<History, 'state' | 'replaceState'>): string | undefined {
  if (!location.hash) return readRuntimeClaimCode()
  const hash = location.hash
  const path = location.pathname
  history.replaceState(history.state && typeof history.state === 'object' ? { ...history.state, current: path } : history.state, '', path)
  clearRuntimeClaimCode()
  if (!/^#userCode=[A-Z2-9]{4}-[A-Z2-9]{4}$/.test(hash)) throw new Error('runtime_claim_code_invalid')
  const userCode = normalizeRuntimeClaimCode(hash.slice('#userCode='.length))
  retainRuntimeClaimCode(userCode)
  return userCode
}

export function retainRuntimeClaimCode(value: string, expiresAt = Date.now() + maximumAgeMs): void {
  pending = { userCode: normalizeRuntimeClaimCode(value), expiresAt: Math.min(expiresAt, Date.now() + maximumAgeMs) }
  try { sessionStorage.setItem(storageKey, JSON.stringify(pending)) } catch { /* Memory still permits same-page SMS sign-in. */ }
}

export function readRuntimeClaimCode(): string | undefined {
  try {
    const stored = sessionStorage.getItem(storageKey)
    if (stored) pending = JSON.parse(stored)
  } catch { /* Memory remains available when browser storage is disabled. */ }
  if (!pending || !Number.isSafeInteger(pending.expiresAt) || pending.expiresAt <= Date.now()
    || pending.expiresAt > Date.now() + maximumAgeMs) { clearRuntimeClaimCode(); return undefined }
  try { return normalizeRuntimeClaimCode(pending.userCode) } catch { clearRuntimeClaimCode(); return undefined }
}

export function clearRuntimeClaimCode(): void {
  pending = undefined
  try { sessionStorage.removeItem(storageKey) } catch { /* Nothing else is persisted. */ }
}
